export enum HomeRoutes {
	Login = '/login',
	SchoolBookkeeping = '/lsb',
	SystemSettings = '/lsb/system-settings',
}
